<p>requirement-game-variable-category-picker works!</p>
